import { render, staticRenderFns } from "./InvoiceList1.vue?vue&type=template&id=2bd25a78&"
import script from "./InvoiceList1.vue?vue&type=script&lang=js&"
export * from "./InvoiceList1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports